import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Button, CardActions, CardContent, Divider, Grid, Menu, MenuItem, Stack, Typography } from '@mui/material';

// project imports
// import BajajAreaChartCard from './BajajAreaChartCard';
import MainCard from 'ui-component/cards/MainCard';
import SkeletonPopularCard from 'ui-component/cards/Skeleton/PopularCard';
import { gridSpacing } from 'store/constant';

// assets
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { useNavigate } from 'react-router';
import axios from 'axios';
import ApiLink from 'API';
import NumberFormat from 'react-number-format';
import PerfectScrollbar from 'react-perfect-scrollbar';
// ==============================|| DASHBOARD DEFAULT - POPULAR CARD ||============================== //

const PopularCard = ({ cusId }) => {
    const theme = useTheme();
    const [SelectMonthYear, setSelectMonthYear] = useState('year');
    const [isLoading, setisLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [Data, setData] = useState([]);
    const navigate = useNavigate();
    async function LoadData() {
        try {
            setData([]);
            setisLoading(true);

            const response = await axios.get(ApiLink + '/api/stockcustomer/customer/popular/' + SelectMonthYear, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (response.status === 200) {
                setData(response.data.data);
                // console.log(response.data.data);

                setisLoading(false);
            } else if (response.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            console.log(error);
            setisLoading(false);
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
            // localStorage.clear();
            // navigate(0);
        }
    }
    useEffect(() => {
        LoadData();
    }, [cusId, SelectMonthYear]);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event, indext) => {
        setAnchorEl(null);
        if (event.target.id !== '') {
            setSelectMonthYear(event.target.id);
        }
    };

    return (
        <>
            {isLoading ? (
                <SkeletonPopularCard />
            ) : (
                <MainCard content={false} sx={{ maxHeight: '75vh' }}>
                    <CardContent>
                        <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 205px)', overflowX: 'hidden' }}>
                            <Grid container spacing={gridSpacing}>
                                <Grid item xs={12}>
                                    <Grid container alignContent="center" justifyContent="space-between">
                                        <Grid item>
                                            <Typography variant="h4">Popular Stocks Top 10</Typography>
                                        </Grid>
                                        <Grid item>
                                            <MoreHorizOutlinedIcon
                                                fontSize="small"
                                                sx={{
                                                    color: theme.palette.primary[200],
                                                    cursor: 'pointer'
                                                }}
                                                aria-controls="menu-popular-card"
                                                aria-haspopup="true"
                                                onClick={handleClick}
                                            />
                                            <Menu
                                                id="menu-popular-card"
                                                anchorEl={anchorEl}
                                                keepMounted
                                                open={Boolean(anchorEl)}
                                                onClose={handleClose}
                                                variant="selectedMenu"
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right'
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right'
                                                }}
                                                value={SelectMonthYear}
                                            >
                                                {/* <MenuItem onClick={handleClose}> Today</MenuItem> */}
                                                {/* <MenuItem onClick={handleClose}> This Month</MenuItem>
                                            <MenuItem onClick={handleClose}> This Year </MenuItem> */}
                                                <MenuItem key={1} onClick={handleClose} selected={SelectMonthYear === 'month'} id="month">
                                                    This Month
                                                </MenuItem>
                                                <MenuItem key={2} onClick={handleClose} selected={SelectMonthYear === 'year'} id="year">
                                                    This Year
                                                </MenuItem>
                                            </Menu>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* <Grid item xs={12} sx={{ pt: '16px !important' }}>
                                <BajajAreaChartCard />
                            </Grid> */}

                                {Data.map((item) => {
                                    return (
                                        <Grid item xs={12}>
                                            <Grid container direction="column">
                                                <Grid item>
                                                    <Grid container alignItems="center" justifyContent="space-between">
                                                        <Grid item>
                                                            <Typography variant="subtitle1" color="inherit">
                                                                {item.productName + ' (' + item.color + ')'}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Grid container alignItems="center" justifyContent="space-between">
                                                                <Grid item>
                                                                    <Typography variant="subtitle1" color="inherit">
                                                                        <NumberFormat
                                                                            thousandsGroupStyle="thousand"
                                                                            value={item.price}
                                                                            prefix="₭"
                                                                            decimalSeparator="."
                                                                            displayType="text"
                                                                            type="text"
                                                                            thousandSeparator={true}
                                                                            allowNegative={true}
                                                                        />
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        sx={{
                                                                            width: 16,
                                                                            height: 16,
                                                                            borderRadius: '5px',
                                                                            backgroundColor: theme.palette.success.light,
                                                                            color: theme.palette.success.dark,
                                                                            ml: 2
                                                                        }}
                                                                    >
                                                                        <KeyboardArrowUpOutlinedIcon fontSize="small" color="inherit" />
                                                                    </Avatar>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle2">Sold:</Typography>
                                                        <Typography variant="h5" sx={{ color: 'success.dark' }}>
                                                            {item.qty}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                            <Divider sx={{ my: 1.5 }} />
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </PerfectScrollbar>
                    </CardContent>
                    <CardActions sx={{ p: 1.25, pt: 0, justifyContent: 'center' }}>
                        <Button size="small" disableElevation>
                            {/* View All
                            <ChevronRightOutlinedIcon /> */}
                        </Button>
                    </CardActions>
                </MainCard>
            )}
        </>
    );
};

PopularCard.propTypes = {
    isLoading: PropTypes.bool
};

export default PopularCard;
